import { TemplateSize } from '@anm/api/modules/templates';

import { CalendarItemProps } from './types';

export const DEFAULT_SIZE = 200;

export const ITEM_SIZES: { [key: number]: number } = {
  1000: DEFAULT_SIZE,
  1130: 227,
  1200: 192,
  1366: 184,
  1540: 211,
  1920: 234
};

export const calcSize = () =>
  Object.keys(ITEM_SIZES).reduceRight((acc, item) => {
    if ((!acc || acc === DEFAULT_SIZE) && window.innerWidth >= +item) {
      return ITEM_SIZES[+item];
    }
    return acc;
  }, DEFAULT_SIZE);

const getSmallestPreview = (thumbs: TemplateSize[]) =>
  [...thumbs].sort((a, b) => a.size.width - b.size.width)[0];

export const getMediaProps = (preview: CalendarItemProps['preview']) => {
  const background = getSmallestPreview(preview);
  const previewSrc = background.url;

  const startOfUrl = previewSrc
    .replace('_thumb.jpg', '')
    .split('_')
    .slice(0, -1)
    .join('_');

  const videoSrc = `${startOfUrl}_hd720.mp4`;

  const { width, height } = background.size;
  const isVerticalVideo = height > width;

  const mediaProps = { videoSrc, previewSrc };

  return [mediaProps, isVerticalVideo] as const;
};
